<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div id="header-container">
  <div>
    <h1 id="header-text">Create Propulsion Forecast Template</h1>
  </div>
  <div>
    <button mat-flat-button color="primary" id="report-button" class="action-button"
            (click)="createForecastTemplate()" [disabled]="planningMarkets.selectedOptions?.length === 0">
      Confirm
    </button>
  </div>
</div>


<div class="p-2 d-flex flex-column gap-16">
  <div class="d-flex flex-row gap-16">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label class="asterisk--before">Select Region</mat-label>
      <mat-select name="regions" id="regions" [(ngModel)]="selectedRegion"
                  (ngModelChange)="getPlanningMarketsAndFilters()" [disabled]="regions?.length === 0">
        <mat-option *ngFor="let region of regions" [value]="region.region">{{ region.region }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label class="asterisk--before">Choose Geography</mat-label>
      <mat-select name="geography" id="geography" [(ngModel)]="selectedGeography"
                  (ngModelChange)="resetAllSelectedFilters(); filteredData = detailData; initializeFilterOptions();"
                  [disabled]="regions?.length === 0">
        <mat-option [value]="0">Subregion</mat-option>
        <mat-option [value]="1">Market Area</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic" *ngIf="selectedGeography === 0">
      <mat-label>Subregions</mat-label>
      <fab-multiselect
        name="subregionFilter"
        [disabled]="geographyFilters.options.length === 0"
        [(ngModel)]="geographyFilters.selectedOptions"
        [options]="geographyFilters.options"
        (ngModelChange)="onFilterChange()">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic" *ngIf="selectedGeography === 1">
      <mat-label>Market Areas</mat-label>
      <fab-multiselect
        name="marketAreaFilter"
        [disabled]="geographyFilters.options.length === 0"
        [(ngModel)]="geographyFilters.selectedOptions"
        (ngModelChange)="onFilterChange()"
        [options]="geographyFilters.options">
      </fab-multiselect>
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic">
      <mat-label class="asterisk--before">Planning Markets</mat-label>
      <fab-multiselect
        name="planningMarketFilter"
        [disabled]="planningMarkets.options.length === 0"
        [(ngModel)]="planningMarkets.selectedOptions"
        [options]="planningMarkets.options">
      </fab-multiselect>
    </mat-form-field>

    <div class="d-flex gap-16 flex-row justify-content-center">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label class="asterisk--before">Start Year</mat-label>
        <mat-select [(ngModel)]="startYear" id="startYear">
          <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label class="asterisk--before">End Year</mat-label>
        <mat-select [(ngModel)]="endYear" id="endYear">
          <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <mat-checkbox [(ngModel)]="createMultipleWorkbooks" id="create-multiple-workbooks">
    Create Multiple Workbooks
  </mat-checkbox>
  <mat-divider></mat-divider>
  <div>
    <h2>Optional Filter Criteria:</h2>

    <mat-radio-group [(ngModel)]="selectedFilter" (ngModelChange)="onSubFilterChange()">
      <mat-radio-button [value]="0">Market Division</mat-radio-button>
      <mat-radio-button [value]="1">Brand Family</mat-radio-button>
      <mat-radio-button [value]="2">Program Code</mat-radio-button>
    </mat-radio-group>
  </div>
  <div>
    <mat-form-field class="w-500-px" subscriptSizing="dynamic" *ngIf="selectedFilter === 0">
      <mat-label>Market Divisions</mat-label>
      <fab-multiselect
        name="marketDivisionFilter"
        [disabled]="marketDivisions.options.length === 0"
        [(ngModel)]="marketDivisions.selectedOptions"
        [options]="marketDivisions.options">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field class="w-500-px" subscriptSizing="dynamic" *ngIf="selectedFilter === 1">
      <mat-label>Brand Families</mat-label>
      <fab-multiselect
        name="brandfamFilter"
        [disabled]="brandfams.options.length === 0"
        [(ngModel)]="brandfams.selectedOptions"
        [options]="brandfams.options">
      </fab-multiselect>
    </mat-form-field>

    <mat-form-field class="w-500-px" subscriptSizing="dynamic" *ngIf="selectedFilter === 2">
      <mat-label>Program Codes</mat-label>
      <fab-multiselect
        name="progCodeFilter"
        [disabled]="programCodes.options.length === 0"
        [(ngModel)]="programCodes.selectedOptions"
        [options]="programCodes.options">
      </fab-multiselect>
    </mat-form-field>
  </div>
</div>
